import { motion, MotionConfig } from "motion/react";

function BoostLink() {
	return (
		<div className="boost-section">
			<MotionConfig transition={{ ease: "easeOut", duration: 0.5 }}>
				<motion.h2
					initial={{ opacity: 0, scale: 0.9 }}
					whileInView={{ opacity: 1, scale: 1 }}
					viewport={{ once: true, amount: 0.3 }}
				>
					Boost your links today
				</motion.h2>

				<motion.button
					className="start-btn"
					initial={{ opacity: 0, scale: 0.5 }}
					whileInView={{ opacity: 1, scale: 1 }}
					viewport={{ once: true, amount: 0.3 }}
				>
					Get Started
				</motion.button>
			</MotionConfig>
		</div>
	);
}

export default BoostLink;
